import { useEffect, useState } from 'react';
import { useGlobalStore } from '../../stores/use-global-store';
// import Tag from '../tag/tag';
import clsx from 'clsx';
import emitter, { EVENT_ENTER_ANIM_FINISH } from '../../utils/mitt';
import Tag from '../tag/tag';

export default function Tags() {
  const { camState } = useGlobalStore();
  const [isShow, setShow] = useState(false);
  useEffect(() => {
    const onFinishEnterAnim = () => {
      setShow(true);
    };
    emitter.on(EVENT_ENTER_ANIM_FINISH, onFinishEnterAnim);
    return () => {
      emitter.off(EVENT_ENTER_ANIM_FINISH, onFinishEnterAnim);
    };
  }, [isShow]);
  return (
    <div
      className={clsx([
        'fit_parent pointer-events-all transition-opacity duration-[1.5s]',
        isShow && camState === 0 ? 'opacity-1 delay-[1.5s]' : 'opacity-0',
      ])}
    >
      <Tag name="仙灵岛" posId="tag-1" />
      <Tag name="苏州城" posId="tag-2" />
      <Tag name="杭州城" posId="tag-3" />
      <Tag name="蜀山" posId="tag-4" />
      <Tag name="归云村" posId="tag-5" />
    </div>
  );
}
